import { DashboardWidget, type DashboardWidgetFC } from '@frontend/grid-dashboard';
import { DashboardWidgetProvider } from '../../provider/dashboard-provider/dashboard-widget.provider';
import { WidgetContent } from './content/widget-content';
import { WidgetHeader } from './header/widget-header';

/**
 * @dashboard-widget
 *
 * id: task-center
 * title: My Tasks
 * description: Stay on top of your day with a centralized view of tasks that need your attention. Track priorities, due dates, and progress to ensure nothing falls through the cracks.
 * icon: task-small
 */

export const TaskCenterDashboardWidget: DashboardWidgetFC = () => {
  return (
    <DashboardWidget>
      <DashboardWidgetProvider>
        <WidgetHeader />
        <WidgetContent />
      </DashboardWidgetProvider>
    </DashboardWidget>
  );
};

TaskCenterDashboardWidget.config = {
  feature: 'task-center',
  size: {
    large: 'large-wide',
    medium: 'large-wide',
    small: 'large-narrow',
    extraSmall: 'large-narrow',
  },
};
